module.exports = __webpack_public_path__ + "static/img/far3.ebd8923a.png";